export const DEFAULT_MIX_ETF_WIKIFOLIO_RANGE = 50;
